import React, { useCallback, useEffect, useRef, useState } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const url = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignments}`;

export default function RequestSummary(props) {
  const { id } = useParams()
  const classes = useStyles(props);
  const [error, setError] = useState();
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [data, setData] = useState();
  
  const loadData = async () => {
    try {
      const list = await OAuthService.getList(`${url}/${id}`);
      let data = list.data;
      setData(data);
    } catch (error) {
      setError(error.message);
      console.log(error);
    }
  };

  useEffect(() => {
    loadData()
  }, [])
  
  return (
    <>
      <FusePageCarded
        classes={{
          content: "flex",
          header: "min-h-72 h-72 sm:h-136 sm:min-h-136",
        }}
        header={
          <ListPageHeader
            componentName="Request Summary"
            pageName={`Request Summary #${id}`}
            showPaginationDropdown={showPaginationDropdown}
            // handleShowRoomQuestionNext={handleShowRoomQuestionNext}
            // handleBack={'/'}
          />
        }
        content={
          <>
            <div className={clsx(classes.root, "px-24 md:px-32")}>
                <Box className="heading">
                    <Typography variant="h6">Request Summary Content</Typography>
                </Box>
            </div>
          </>
        }
        innerScroll
      />
    </>
  );
}
